import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { X, SlidersHorizontal } from 'lucide-react';
import SubscriptionFilters from './SubscriptionFilters';

const SubscriptionFilterSidebar = ({
  open,
  onClose,
  statusFilter,
  planFilter,
  networkFilter,
  packageFilter,
  onStatusChange,
  onPlanChange,
  onNetworkChange,
  onPackageChange,
  onClearFilters,
  subscriptions
}) => {
  return (
    <AnimatePresence>
      {open && (
        <>
          {/* Overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-40 bg-black bg-opacity-40"
            onClick={onClose}
          />

          {/* Sidebar */}
          <motion.aside
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            className="flex fixed top-0 right-0 z-50 flex-col w-full max-w-xs h-full bg-white border-l border-gray-200 shadow-2xl"
          >
            <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100">
              <div className="flex gap-2 items-center text-lg font-semibold text-gray-900">
                <SlidersHorizontal className="w-5 h-5 text-purple-600" />
                Filters
              </div>
              <button
                onClick={onClose}
                className="p-2 text-gray-500 rounded-full transition-colors hover:bg-gray-100 hover:text-gray-900"
                aria-label="Close filters sidebar"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="overflow-y-auto flex-1 p-6">
              <SubscriptionFilters
                statusFilter={statusFilter}
                planFilter={planFilter}
                networkFilter={networkFilter}
                packageFilter={packageFilter}
                onStatusChange={onStatusChange}
                onPlanChange={onPlanChange}
                onNetworkChange={onNetworkChange}
                onPackageChange={onPackageChange}
                onClearFilters={onClearFilters}
                subscriptions={subscriptions}
              />
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};

export default SubscriptionFilterSidebar; 